import React, { useContext } from 'react'
import { CashflowEventsContext } from '../context'
import { TabHeader } from '@components/TabHeader'

import messages from '../messages.json'

export const Header = () => {
  const { state } = useContext(CashflowEventsContext)
  const { filter, screen, joint } = state
  return (
    <TabHeader title={messages.heading}>
      {
        !joint &&
        <TabHeader.Filter filter={filter} view={screen} />
      }
    </TabHeader>
  )
}
